import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import { first } from 'lodash'
import {
    ADMIN_UPLOAD_FILES,
    ADMIN_UPLOAD_TIME,
    CLIENT_ROS_FILE,
    REUPLOAD_DELIVERABLE_FILES,
    REUPLOAD_TIME,
} from './contants'
import { DELIVERABLE_FILES } from './files-helper'
import { isCampaignProduct } from './slug'

export const DENIED_STATUS = 'denied'
export const APPROVED_STATUS = 'approved'
export const PENDING_STATUS = 'pending'
export const validProofStatuses = [DENIED_STATUS, APPROVED_STATUS]
export const validProofStatusesToShowButtons = [PENDING_STATUS, DENIED_STATUS]
export const ENEVELOPE = 'Envelope'
export const LETTER = 'Mailer'
export const SHEET_URL_FIELD = 'sheet_url'

export const MAILING_DATE = 'Mailing Date'
export const PROOF_MAILING_DATE_FIELD = 'mailing_date'
export const BATCH_MAILING = 'Batch Mailing'
export const SEND_BATCH_EVERY = 'Send Batch Every'
export const TIME_BETWEEN_EACH_TOUCH = 'Time Between Each Touch'
export const SHIPPING_ADDRESS_FIELD = 'Shipping Address'

export const MAIL_ALL_AT_ONCE_TEXT = 'Mail all at once'

export const excludeProductsFromProof = [
    'Listsource Access - One Month',
    'Purchase a List',
    'Receive your undeliverable leads ?',
    'Design My File (upload required) +$99',
    'Unsealed + $65',
    'Professional Shipping Fee',
    'Shipping Fee',
    'Undeliverable Mail Fee',
    'Unsealed Fee',
    'Returned mail add-on product',
    'Base List Fee $199 (up to 1,000 records)',
    'Premium Lead Lists',
    'Offer Per item',
    'Store Credit',
    'Unsealed Fee',
    'Real Penned Envelope',
    'Add Streetview Image to template?',
    'Add Streetview Image',
    'Pages & Printing',
    'Pages & Printing - 2 pages, double-sided (+$0.18 / piece)',
    'Pages & Printing - 1 page, single-sided',
    'Pages & Printing - 1 page, double-sided (+$0.06 / piece)',
    'Pages & Printing - 2 pages, single-sided (+$0.12 / piece)',
]

export const metasForProof = [
    DELIVERABLE_FILES,
    MAILING_DATE,
    BATCH_MAILING,
    SEND_BATCH_EVERY,
    TIME_BETWEEN_EACH_TOUCH,
    'Number of Touches',
    'Campaign Template',
    'Touches',
    SHIPPING_ADDRESS_FIELD,
]

const dateFormat = 'MMM D, YYYY'
const HourFormat = ' h:mm A'

export const formateDateForProof = (date, onlyDate = false) => {
    if (!date) return
    // make date safari compatible
    date = date.replace(/-/g, '/')
    date = new Date(Date.parse(`${date} UTC`))
    const format = onlyDate ? dateFormat : dateFormat + HourFormat
    return dayjs(date).format(format)
}

export const formatDateToSupportSafari = (date) => {
    const dateParts = date.split('-')
    const year = dateParts[2]
    const month = dateParts[0]
    const day = dateParts[1]
    return `${year}-${month}-${day}`
}

export const formateDateWithProofFormat = (date, onlyDate = false) => {
    // we need to check if its a valid date
    if (!date) return 'Invalid Date'

    // this date should not be 0000-00-00
    if (date === '0000-00-00') return 'Invalid Date'

    const format = onlyDate ? dateFormat : dateFormat + HourFormat

    if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
        date = formatDateToSupportSafari(date)
    }
    return dayjs(date).format(format)
}

export const directToProofLink = ({ orderId, lineId, touch, router }) => {
    return router.push(
        touch
            ? `/my-account/proofs/${orderId}?line_id=${lineId}&touch=${touch}`
            : `/my-account/proofs/${orderId}?line_id=${lineId}`,
    )
}

export const validProofProducts = (items) => {
    return items.filter((item) => {
        return !excludeProductsFromProof.includes(item.name)
    })
}

export const hasMultipleProducts = (order) => {
    if (!order) return
    const validItems = validProofProducts(order.line_items)
    return validItems.length > 1
}

export const getFirstProduct = (items) => {
    const validItems = validProofProducts(items)
    return validItems.length > 0 ? validItems[0] : null
}

export const getFirstProofProductName = (items) => {
    const firstProduct = getFirstProduct(items)
    return firstProduct ? firstProduct.parent_name || firstProduct.name : false
}

export const getFirstValidProductFromOrder = (order) => {
    return getFirstProduct(order?.line_items)
}

export const getFirstItemBatches = (items) => {
    const { meta_data } = first(items)
    const batches = meta_data.find((meta) => meta.key === 'Batch Mailing')
    return batches ? batches.value : MAIL_ALL_AT_ONCE_TEXT
}

export const humanReadableProofStatus = (status) => {
    const statusObject = {
        pending: 'Proof Ready',
        approved: 'View Approved Proof',
        denied: 'Proof Denied',
        'proof-denied': 'Proof Denied',
        preparing: 'Preparing Proof ',
        'list-reuploaded-r': 'New List - Resending Proof',
    }

    return statusObject[status] || status
}

export const humanReadableProofStatusTitle = (status) => {
    const statusObject = {
        pending: 'Pending Approval',
    }

    return statusObject[status] || status
}

export const getProofClassForButton = (status) => {
    const classObject = {
        approved: 'bg-green-600',
    }

    return classObject[status] || status
}

export const getProofClass = (status) => {
    const classObject = {
        pending: 'bg-blue-100 border border-blue-500',
        approved: 'bg-green-100 border border-green-500',
        denied: 'bg-red-100 border border-red-500',
    }

    return classObject[status] || status
}

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
const defaultTimezone = 'America/New_York'
dayjs.tz.setDefault(defaultTimezone)

const isDatewithin5BusinessDaysRange = (date) => {
    // // Get the current date
    // const currentDate = new Date()

    // // Get the date 5 days from now
    // const fiveDaysFromNow = new Date()
    // fiveDaysFromNow.setDate(currentDate.getDate() + 5)

    // // Get the date you want to check
    const dateToCheck = new Date(date) // This can be any date

    // // Check if the date is within the next 5 days
    // return dateToCheck <= fiveDaysFromNow && dateToCheck >= currentDate

    // Calculate the date 5 business days from today
    const today = new Date()
    let businessDaysToAdd = 4
    let daysToAdd = 0
    while (businessDaysToAdd > 0) {
        daysToAdd++
        const tempDate = new Date(
            today.getTime() + daysToAdd * 24 * 60 * 60 * 1000,
        )
        if (tempDate.getDay() !== 0 && tempDate.getDay() !== 6) {
            businessDaysToAdd--
        }
    }
    const fiveBusinessDaysFromToday = new Date(
        today.getTime() + daysToAdd * 24 * 60 * 60 * 1000,
    )

    // return givenDate > fiveBusinessDaysFromToday
    return dateToCheck <= fiveBusinessDaysFromToday && dateToCheck >= today
}

const isBeforeDate = (date) => {
    return dayjs(new Date(date)).isBefore(dayjs(new Date()))
}

const isSunday = (date) => {
    return dayjs(new Date(date)).format('dddd') === 'Sunday'
}

const isSaturday = (date) => {
    return dayjs(new Date(date)).format('dddd') === 'Saturday'
}

const realPenProofDate = (date) => {
    if (
        isDatewithin5BusinessDaysRange(date) ||
        isSaturday(date) ||
        isSunday(date) ||
        isBeforeDate(date)
    ) {
        return true
    }
    return false
}

/*
 * Determines if a date should be disabled in the calendar based on mail availability rules
 *
 * The rules follow this pattern (based on NY time cutoffs):
 * - Current time between Thursday 11:59 PM → Sunday 11:59 PM: Earliest mail date is Monday
 * - Current time between Sunday 11:59 PM → Monday 11:59 PM: Earliest mail date is Tuesday
 * - Current time between Monday 11:59 PM → Tuesday 11:59 PM: Earliest mail date is Wednesday
 * - Current time between Tuesday 11:59 PM → Wednesday 11:59 PM: Earliest mail date is Thursday
 * - Current time between Wednesday 11:59 PM → Thursday 11:59 PM: Earliest mail date is Friday
 *
 * Weekend days (Saturday and Sunday) are always disabled.
 *
 * @param {Object} params - Parameters object
 * @param {Date} params.date - The date to check
 * @param {boolean} params.isRealPen - Flag to determine if this is for a real pen (uses different logic)
 * @returns {boolean} - True if the date should be disabled, false otherwise
 */
export function tileDisabled({ date, isRealPen = false }) {
    if (isRealPen) return realPenProofDate(date)

    // Convert input date to a JavaScript Date object
    const tileDate = date instanceof Date ? date : new Date(date)

    // Get current date/time in local timezone
    const now = new Date()

    // Convert to Eastern Time (America/New_York)
    // This is a stable way to get the current time in EST/EDT that handles daylight saving
    const estOptions = { timeZone: 'America/New_York' }
    const estDateParts = now
        .toLocaleDateString('en-US', {
            ...estOptions,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        })
        .split('/')

    const estTimeParts = now
        .toLocaleTimeString('en-US', {
            ...estOptions,
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        })
        .split(':')

    // Create a new Date object representing the current time in EST
    // Month is 0-indexed in JavaScript Date
    const estNow = new Date(
        parseInt(estDateParts[2]), // year
        parseInt(estDateParts[0]) - 1, // month (0-indexed)
        parseInt(estDateParts[1]), // day
        parseInt(estTimeParts[0]), // hour
        parseInt(estTimeParts[1]), // minute
        parseInt(estTimeParts[2]), // second
    )

    // Get day of week and hour in Eastern Time
    const currentDay = estNow.getDay()
    const currentHour = estNow.getHours()
    const currentMinute = estNow.getMinutes()

    // Get day of week for the tile (0=Sunday, 1=Monday, etc.)
    const tileDayOfWeek = tileDate.getDay()

    // Disable Saturday (6) and Sunday (0)
    if (tileDayOfWeek === 0 || tileDayOfWeek === 6) {
        return true
    }

    // Determine the earliest mail day based on current day AND time in EST
    // Updated logic based on the provided table
    let earliestMailDay

    // Check if it's before or after 11:59 PM
    const isBeforeMidnight =
        currentHour < 23 || (currentHour === 23 && currentMinute < 59)

    // Monday before midnight -> Wednesday (day 3)
    if (currentDay === 1 && isBeforeMidnight) {
        earliestMailDay = 3 // Wednesday
    }
    // Tuesday before midnight -> Thursday (day 4)
    else if (currentDay === 2 && isBeforeMidnight) {
        earliestMailDay = 4 // Thursday
    }
    // Wednesday before midnight -> Friday (day 5)
    else if (currentDay === 3 && isBeforeMidnight) {
        earliestMailDay = 5 // Friday
    }
    // Thursday before midnight -> Monday (day 1)
    else if (currentDay === 4 && isBeforeMidnight) {
        earliestMailDay = 1 // Monday
    }
    // Friday, Saturday, or (Monday after midnight) -> Tuesday (day 2)
    else if (
        currentDay === 5 ||
        currentDay === 6 ||
        (currentDay === 1 && !isBeforeMidnight) ||
        (currentDay === 0 && isBeforeMidnight)
    ) {
        earliestMailDay = 2 // Tuesday
    }
    // Any other case (after deadline) -> shift to next day's rule
    else {
        // After Monday midnight -> Thursday (day 4)
        if (currentDay === 1) {
            earliestMailDay = 4 // Thursday
        }
        // After Tuesday midnight -> Friday (day 5)
        else if (currentDay === 2) {
            earliestMailDay = 5 // Friday
        }
        // After Wednesday midnight -> Monday (day 1)
        else if (currentDay === 3) {
            earliestMailDay = 1 // Monday
        }
        // After Thursday midnight -> Tuesday (day 2)
        else if (currentDay === 4) {
            earliestMailDay = 2 // Tuesday
        }
        // After Sunday midnight -> Wednesday (day 3)
        else {
            earliestMailDay = 3 // Wednesday (for Sunday after midnight)
        }
    }

    // Calculate the actual date for the earliest mail day in EST
    const earliestMailDate = new Date(estNow)
    let daysToAdd

    if (earliestMailDay > currentDay) {
        // Target day is later this week
        daysToAdd = earliestMailDay - currentDay
    } else {
        // Target day is in next week
        daysToAdd = 7 + (earliestMailDay - currentDay)
    }

    earliestMailDate.setDate(earliestMailDate.getDate() + daysToAdd)

    // Set to start of day (midnight)
    earliestMailDate.setHours(0, 0, 0, 0)

    // Create a copy of tile date with time set to midnight for comparison
    const tileStartOfDay = new Date(tileDate)
    tileStartOfDay.setHours(0, 0, 0, 0)

    // Disable if the calendar tile is before earliest mail date
    return tileStartOfDay < earliestMailDate
}

export const isCurrentMailingDateUnAvailable = ({ date, isRealPen }) => {
    return tileDisabled({ date, isRealPen })
}

export const isValidDateWithinOneYear = ({ item = {}, date }) => {
    return getAvailableOneYearArray(item).includes(
        dayjs(date).format('YYYY-MM-DD'),
    )
}

export const getAvailableOneYearArray = (item = {}) => {
    const startingDay = new Date()
    let datesArray = []

    for (var i = 1; i < 365; i++) {
        let thisDay = new Date(startingDay)
        thisDay.setDate(startingDay.getDate() + i)
        datesArray.push({
            date: thisDay,
            disabled: tileDisabled({
                date: thisDay,
                isRealPen: item?.isRealPen,
            }),
        })
    }

    datesArray = datesArray.filter((item) => !item.disabled)
    let returnDateArray = []

    datesArray.forEach((element) => {
        returnDateArray.push(dayjs(element.date).format('YYYY-MM-DD'))
    })

    return returnDateArray
}

export const shouldShowShippingAddress = (line) => {
    const isRealPen = line.name?.includes('Real Pen')
    const mailForCustomer = line?.meta_data?.find(
        (meta) => meta.key === 'Mail For Customer',
    )
    return mailForCustomer && isRealPen && mailForCustomer?.value == 'no'
}

export const getOrderShippingAddressInText = (order) => {
    const excludedKeys = ['country', 'phone']
    let mailingAddress = ''
    for (let key in order?.shipping) {
        if (excludedKeys.includes(key)) continue
        mailingAddress +=
            key.replace('_', ' ') + ': ' + order?.shipping[key] + '<br/>'
    }

    return mailingAddress
}

// function timeObjectToUse(obj1, obj2) {
//     const date1 = new Date(obj1.value)
//     const date2 = new Date(obj2.value)

//     if (date1 > date2) {
//         return obj1
//     } else if (date1 < date2) {
//         return obj2
//     } else {
//         return obj1
//     }
// }

// const fileKeyName = (timeObject) => {
//     if (timeObject.key === REUPLOAD_TIME) {
//         return REUPLOAD_DELIVERABLE_FILES
//     } else if (timeObject.key === ADMIN_UPLOAD_TIME) {
//         return ADMIN_UPLOAD_FILES
//     }
// }

export const DownloadfileToUse = (line) => {
    try {
        const reuploaded_time = line.meta_data.find(
            (meta) => meta.key === REUPLOAD_TIME,
        )
        const admin_uploaded_time = line.meta_data.find(
            (meta) => meta.key === ADMIN_UPLOAD_TIME,
        )

        const client_ros_file = line.meta_data.find(
            (meta) => meta.key === CLIENT_ROS_FILE,
        )

        if (reuploaded_time) {
            return line.meta_data.find(
                (meta) => meta.key === REUPLOAD_DELIVERABLE_FILES,
            )
        }

        if (admin_uploaded_time) {
            return line.meta_data.find(
                (meta) => meta.key === ADMIN_UPLOAD_FILES,
            )
        }

        // If a ROS file is found in metadata, return it immediately.
        if (client_ros_file) {
            return client_ros_file
        }

        // Default case, try finding deliverable files.
        const found = line.meta_data.find(
            (meta) => meta.key === DELIVERABLE_FILES,
        )
        // Throw an error if no file is found (this is caught by the catch block below).
        if (!found) throw new Error('No file found')
        return found
    } catch {
        return { key: DELIVERABLE_FILES, value: '' }
    }
}

export const isProofCampaignProduct = (order) =>
    isCampaignProduct({
        slug: String(getFirstProofProductName(order.line_items)).toLowerCase(),
    })

export const phpGMTtoJsGMT = (date) => {
    const inputDate = new Date(date)

    // Get the timestamp of the input date in milliseconds since Unix Epoch
    const unixTimestamp = inputDate.getTime()

    // Calculate the offset in milliseconds between local time and GMT
    const offsetMillis = new Date().getTimezoneOffset() * 60 * 1000

    // Calculate the GMT timestamp by subtracting the offset from the Unix timestamp
    const gmtTimestamp = unixTimestamp - offsetMillis

    // Create a new Date object with the GMT timestamp
    const gmtDate = new Date(gmtTimestamp)

    // Get the string representation of the GMT date and time
    const gmtString = gmtDate.toUTCString()

    return gmtString
}
